/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import videojs from "!video.js";

import { CurrentAdTracker } from "./CurrentAdTracker";

// transpiling issue with video.js, !syntax with disabled webpack loader required
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved

export class CurrentAdTrackerVideoJS extends CurrentAdTracker {
  constructor(manager: google.ima.AdsManager, player: videojs.Player) {
    super(manager, player);
  }

  protected updateAdMetadata = () => {
    this.player.trigger("admetadataupdate");
  };
}
